import React, { useEffect, useState } from "react";
import Breadcrumb from "../../parts/Breadcrumb";
import ColumnHeader from "../../components/AccessRight/ColumnHeader";
import ColumnRow from "../../components/AccessRight/ColumnRow";
import Label from "../../components/AccessRight/Label";
import labels from "../../constants/AccessRight";
import configuration from "../../config";
import { each } from "underscore";
import { toast } from "react-toastify";
import Dropdown from "../../components/Form/Dropdown";
import Loader from "../../components/Loader/Loader";
import { getAccessRights } from "../../utils/common";
import { useHistory } from "react-router-dom";

// List Access Rights
function View() {
  const [columnHeaders, setColumn] = useState([
    { title: "View", value: "is_view", selectAll: false },
    { title: "Add", value: "is_add", selectAll: false },
    { title: "Edit", value: "is_edit", selectAll: false },
    { title: "Delete", value: "is_delete", selectAll: false },
  ]);
  const [role, setRole] = useState([]);
  const [module, setModule] = useState([]);
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [accessRights, setAccessRights] = useState();
  const history = useHistory();

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "PERMISSION");
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
      setAccessRights(rightsData);
    });
    configuration
      .getAPI({ url: "role/list", params: { status: "active" } })
      .then((data) => {
        if (data.payload) {
          each(data.payload, (single) => {
            single.value = single.role_id;
          });
          setRole(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }, []);

  function changeStatus(field, e) {
    setFields({ ...fields, roleID: e.target.value });
    let error = {};
    error["roleID"] = "";
    setErrors({ ...error });
    if (e.target.value && e.target.value !== "") {
      setIsLoader(true);
      configuration
        .getAPI({
          url: "common/list-access",
          params: { roleID: e.target.value },
        })
        .then((data) => {
          setIsLoader(false);
          if (data.payload) {
            setModule(data.payload);
            each(columnHeaders, (single) => {
              single.selectAll = false;
            });
            setColumn([...columnHeaders]);
          } else {
            setIsLoader(false);
            setModule([]);
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    } else {
      setIsLoader(false);
      setModule([]);
    }
  }

  function allCheckBoxChange(code, e) {
    each(module, (single) => {
      single.data[e.target.value] = e.target.checked;
    });
    each(columnHeaders, (single) => {
      if (single.value === e.target.value) {
        single.selectAll = e.target.checked;
      }
    });
    setModule([...module]);
    setColumn([...columnHeaders]);
  }
  function handleSubmit() {
    setErrors({});
    if (!fields.roleID) {
      let error = {};
      error["roleID"] = "Please select role";
      setErrors({ ...error });
      return false;
    }
    setIsLoader(true);
    configuration
      .postAPI({
        url: "common/update-permission",
        params: { ...fields, accessData: module },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          return toast.success("Permission updated Successfully");
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  function individualCheckBoxChange(moduleIndex, columnKey, e) {
    const checked = e.target.checked;

    const updatedModules = [...module];
    updatedModules[moduleIndex].data[columnKey] = checked;
    setModule(updatedModules);

    const allChecked = updatedModules.every((mod) => mod.data[columnKey]);
    const updatedColumns = columnHeaders.map((col) =>
      col.value === columnKey ? { ...col, selectAll: allChecked } : col
    );
    setColumn(updatedColumns);
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.permission} />
      <div className="py-6 sm:px-6">
        <div className="relative">
          <section className="px-4" aria-labelledby="contact-heading">
            <div className="flex flex-col">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="mx-auto py-8 lg:flex lg:items-center lg:justify-between">
                    <div className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-4xl text_theme">
                        Permissions
                      </h2>
                    </div>
                  </div>
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg bg-white box_bg border-bottom-theme">
                    <div className="lg:gap-y-0 lg:gap-x-8">
                      <div className="space-y-8 divide-y divide-gray-200 sm:border-b border-bottom-theme">
                        <div className="sm:p-6">
                          <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            {/* Role Dropdown */}
                            <div className="sm:col-span-3 flex flex-col justify-end h-full">
                              <Label title="Role" />
                              <div className="mt-3">
                                <Dropdown
                                  id="roleID"
                                  name="roleID"
                                  title="Role"
                                  value={fields.roleID}
                                  status={role}
                                  handleChange={(field, e) =>
                                    changeStatus(field, e)
                                  }
                                />
                                {errors.roleID && (
                                  <label
                                    htmlFor="roleID"
                                    className="block text-base text_theme font-medium text-red-700"
                                  >
                                    {errors.roleID}
                                  </label>
                                )}
                              </div>
                            </div>

                            {/* Save Button */}
                            <div className="sm:col-span-3 pt-9 w-44">
                              {accessRights?.edit ? (
                                <button
                                  type="submit"
                                  onClick={handleSubmit}
                                  className="w-auto mr-3 mb-1 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 xl-admin-btn"
                                >
                                  Save Changes
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-600 opacity-50 cursor-not-allowed"
                                >
                                  Save Changes
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col">
                        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg border-bottom-theme">
                              {module?.length > 0 ? (
                                <table
                                  className="min-w-full divide-y divide-gray-200"
                                  style={{ borderCollapse: "inherit" }}
                                >
                                  <thead className="bg-gray-50 permissions_data_heading">
                                    <tr>
                                      <th
                                        scope="col"
                                        className="relative px-6 py-3 text-left text_theme"
                                      >
                                        Module Name
                                      </th>
                                      {columnHeaders.map((header) => {
                                        return (
                                          <ColumnHeader
                                            title={header.title}
                                            key={header.value}
                                            id={header.value}
                                            name={header.value}
                                            checked={header.selectAll}
                                            disabled={
                                              accessRights?.edit ? false : true
                                            }
                                            value={header.value}
                                            handleChange={(e) =>
                                              allCheckBoxChange(header.value, e)
                                            }
                                            className="cursor-pointer"
                                          />
                                        );
                                      })}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {module.map((mod, modIndex) => (
                                      <tr
                                        key={mod.code}
                                        className={
                                          modIndex % 2 === 0
                                            ? "bg-white box_bg"
                                            : "bg-gray-50 box_bg"
                                        }
                                      >
                                        <td className="px-6 py-4 whitespace-nowrap text-basefont-medium text-gray-900 text_theme">
                                          {mod.title}
                                        </td>
                                        {columnHeaders.map((header, ind) => (
                                          <td key={ind} className="p-0">
                                            <div className="flex items-center gap-1 p-0 m-0 leading-none h-5">
                                              <ColumnRow
                                                key={header.title}
                                                id={header.title}
                                                name={header.title}
                                                checked={mod.data[header.value]}
                                                disabled={
                                                  accessRights?.edit
                                                    ? false
                                                    : true
                                                }
                                                value={header.value}
                                                handleChange={(e) =>
                                                  individualCheckBoxChange(
                                                    modIndex,
                                                    header.value,
                                                    e
                                                  )
                                                }
                                              />
                                              <svg
                                                fill="none"
                                                viewBox="0 0 14 14"
                                                className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                                              >
                                                <path
                                                  d="M3 8L6 11L11 5"
                                                  strokeWidth={2}
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  className="opacity-0 group-has-[:checked]:opacity-100"
                                                />
                                                <path
                                                  d="M3 7H11"
                                                  strokeWidth={2}
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  className="opacity-0 group-has-[:indeterminate]:opacity-100"
                                                />
                                              </svg>
                                            </div>
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <p className="text-center h-64 flex items-center justify-center">
                                  There are no access rights available.
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>{" "}
    </>
  );
}

export default View;
